import { ClientError } from "./clients/errors.js";
const DEFAULT_ERROR_MESSAGE = "unknown error from server";
const DEFAULT_ERROR_STATUS_CODE = 500;
const DEFAULT_ERROR_CODE = "client-error";
const ClientErrors = [
    // default error code
    DEFAULT_ERROR_CODE,
    "auth/invalid-token",
    "auth/missing-token",
    "auth/expired",
    "auth/user-disabled",
];
export class HTTPError extends Error {
    constructor(status, code) {
        let _code = "unknown";
        let message = "Unknown Error";
        if (typeof code === "string") {
            _code = code;
            message = `WebError (${code})`;
        }
        if (typeof code === "object") {
            if (code.code)
                _code = code.code;
            if (code.message)
                message = code.message;
        }
        super(message);
        this.message = message;
        this._code = _code;
        this._status = status;
        this.name = "WebError";
    }
    get code() {
        return this._code;
    }
    get statusCode() {
        return this._status;
    }
}
export const clientErrorFromResponse = (status, obj) => new HTTPError(status, obj);
/**
 * Thrown when multiple retry attempts has been exhausted
 */
export class FailedAfterRetryError extends ClientError {
    constructor(lastCause) {
        super(`failed after multiple attempts`);
        this.cause = lastCause;
        this.name = "FailedAfterRetryError";
    }
}
/**
 * Error thrown when fetch call responds with
 * 401, cause by an expired token
 */
export class TokenError extends HTTPError {
    constructor(status, output) {
        var _a;
        super(status, output
            ? { code: output.code, message: (_a = output.message) !== null && _a !== void 0 ? _a : "invalid token" }
            : undefined);
        this.name = "TokenError";
    }
}
/**
 * Thrown when there is a gnereix provlem of the refresh token.
 */
export class RefreshTokenError extends TokenError {
    constructor(status, output) {
        super(status, output ? { code: output.code, message: output.message } : undefined);
        this.name = "RefreshTokenError";
    }
}
/**
 * Thrown when the refresh token is missing, but the access token
 * is defined. Thus unable to refresh the access token
 */
export class UserMissingRefreshTokenError extends ClientError {
    constructor(output) {
        super(output === null || output === void 0 ? void 0 : output.message);
        this.name = "UserMissingRefreshTokenError";
    }
}
/**
 * Error thrown when the refresh token has expired.
 * This should prompt the user to re-login
 */
export class RefreshTokenExpiredError extends RefreshTokenError {
    constructor(status, output) {
        super(status, output);
        this.name = "RefreshTokenExpiredError";
    }
}
/**
 * Error thrown when fetch call responds with
 * 401, cause by an expired token
 */
export class TokenExpiredError extends HTTPError {
    constructor(status, message) {
        super(status, {
            code: "auth/token-expired",
            message: message !== null && message !== void 0 ? message : "authentication token expired",
        });
        this.name = "TokenExpiredError";
    }
}
/**
 * Error thrown when the client is missing the
 * session access token, but has the corresponding refresh token
 */
export class UserAccessMissingError extends HTTPError {
    constructor(status, output) {
        var _a;
        super(status, output
            ? {
                code: output.code,
                message: (_a = output === null || output === void 0 ? void 0 : output.message) !== null && _a !== void 0 ? _a : "user access token missing, but has refresh token",
            }
            : undefined);
        this.name = "UserAccessMissingError";
    }
}
